// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<div id='customer-landing-page' class="box"></div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/landing-page/customer-landing-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;